import type { WhitelabelSettings } from './model.ts';

/**
 * CSS variables that are safe for V3 (brand assets and text content, not color overrides).
 * If a WL theme only contains these, V3 can still be used.
 *
 * Source: whitelabel-editor.service.js — brand variables + all `isTextInput: true` fields.
 */
const V3_SAFE_CSS_VARS = new Set([
  // Brand assets
  '--brand-logo',
  '--brand-favicon',
  '--brand-name',
  // Text content (isTextInput fields from WL editor)
  '--component-login__welcome-message',
  '--component-login__welcome-sub-message',
  '--component-join-invite__welcome-message',
  '--component-publisher-registration__welcome-message',
  '--component-buyer-registration__welcome-message',
]);

/**
 * Checks if whitelabel settings have custom color overrides that are incompatible with V3.
 * Returns true if the production theme contains CSS variables beyond brand assets and text content.
 */
export function hasCustomColorTheme(settings: WhitelabelSettings | null | undefined): boolean {
  if (!settings || !settings.enabled) {
    return false;
  }

  const theme = settings.productionTheme;
  if (!theme || !theme.default) {
    return false;
  }

  return Object.keys(theme.default).some(key => !V3_SAFE_CSS_VARS.has(key));
}
